import { Breadcrumbs, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageHeaderText from 'components/base/page-header-text';
import SingleBottomNav from 'components/base/single-bottom-nav';
import { SuccessModal } from 'components/base/success-modal';
import { apiService } from 'services/base.service';
import { BrandOption, MealCategoryType, MealType } from 'utils/types';
import { ROUTE_KEYS } from 'utils/constants';
import NewCategoryModal from 'components/new-category-modal';
import SelectBrand from 'components/select-brand';
import Select from 'components/base/select';
import { multiselectOptionsType } from '../convert-meal-category-to-addon-category';

type formDataType = {
  meal_category_ids: string[] | [];
  brand_id?: any;
  new: boolean;
  meal_id: string;
  meal_category_description: string;
  meal_category_name: string;
};
const DuplicateMeal = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState<BrandOption[]>([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [mealData, setMealData] = useState<MealType | null>(null);

  const [formData, setFormData] = useState({
    brand_id: [],
    meal_category_ids: [],
    meal_id: id
  } as formDataType);

  const [mealCategories, setMealCategories] = useState([] as multiselectOptionsType[]);
  const handleCloseCategoryModal = (newCategoryItems?: BrandOption[]) => {
    setIsNew(false);
    if (newCategoryItems) {
      const ids = newCategoryItems?.map((item) => item.value);
      setMealCategories([...newCategoryItems, ...mealCategories]);
      setFormData({ ...formData, meal_category_ids: [...formData.meal_category_ids, ...ids] });
    }
  };

  const fetchMealData = async () => {
    try {
      const response = await apiService.get(`meal/${id}`);
      const { data } = response.data;
      setMealData(data);
    } catch (error: any) {
      console.log({ error });
    }
  };

  useEffect(() => {
    fetchMealData();
  }, []);

  useEffect(() => {
    const brandValue = selectedBrand.map((item) => item.value);
    setFormData({ ...formData, brand_id: brandValue });
  }, [selectedBrand]);

  const breadcrumbs = [
    {
      name: mealData?.brand?.name ? `View ${mealData.brand.name}` : '...',
      path: `${ROUTE_KEYS.MEALS}?brand_id=${mealData?.brand?.id}`
    },
    {
      name: mealData?.meal_category?.name ?? '...',
      path: `${ROUTE_KEYS.MEALS}/${mealData?.meal_category_id}`
    },
    {
      name: 'Duplicate',
      path: ''
    }
  ];

  const fetchCategoryData = async () => {
    try {
      setLoading(true);
      const brand_ids = selectedBrand.map((item: any) => item.value);
      const res: any = await apiService.post(`marketing/brand/meal-categories`, {
        data: { brand_ids: brand_ids }
      });
      const { data } = res.data;
      const categoryArray = data.map((category: MealCategoryType) => {
        return {
          value: category.id,
          text: `${category.name} - ${category.brand.name}`
        };
      });
      setMealCategories(categoryArray);
    } catch {
      setMealCategories([] as any);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategoryData();
  }, [formData?.brand_id]);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      const payload = {
        meal_category_ids: formData?.meal_category_ids,
        meal_id: formData?.meal_id
      };
      await apiService.post(`marketing/meal/duplicate`, { data: payload });
      toast(<ToastMessage type='success' message='Meal duplicated Successfully' />);
    } catch {
      toast(<ToastMessage type='error' message='There was a problem duplicating meal' />);
    } finally {
      setShowSuccess(true);
      setLoading(false);
    }
  };

  return (
    <div>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <PageHeaderText
        title={`Duplicate ${mealData?.name ?? ''}`}
        description='This lets you duplicate a meal to various meal categories'
      />
      <div className='max-w-[755px]'>
        <p className='font-medium text-sm mb-1'>Select brand(s)</p>

        <SelectBrand brands={selectedBrand} setBrands={setSelectedBrand} hasSearch multiple />
        <p className='font-medium text-sm mt-[24px]'>Select meal category</p>
        <Select
          multiple
          placeholder='Select Category'
          values={formData?.meal_category_ids}
          options={mealCategories}
          onChange={(e) => setFormData({ ...formData, meal_category_ids: e })}
        />

        <div className='mt-8 bg-[#F9F6F6] rounded-md border-[0.5px] border-[#EEECEC] px-[20px] py-3'>
          <Input
            type='checkbox'
            name='is_new'
            label='Add new Meal category'
            checked={isNew}
            onChange={(e) => setIsNew(e.target.checked)}
          />
        </div>
        <SingleBottomNav
          onConfirm={handleConfirm}
          btnDisabled={formData?.meal_category_ids.length === 0}
          loading={loading}
        />
      </div>

      <SuccessModal onClose={() => setShowSuccess(false)} show={showSuccess}>
        Duplication Successful
      </SuccessModal>
      <NewCategoryModal
        isOpen={isNew}
        onClose={handleCloseCategoryModal}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
      />
    </div>
  );
};

export default DuplicateMeal;
